module.exports = __webpack_public_path__ + "static/media/ReportedHolrs.9e731c84.png";